import { FC } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

type StepIndicatorProps = {
  numberOfSteps: number;
  currentStepIndex: number;
};

const StepIndicator: FC<PropsWithClassName<StepIndicatorProps>> = ({ className, numberOfSteps, currentStepIndex }) => {
  return (
    <div className={cn('flex items-center justify-center gap-2 p-2', className)}>
      {Array.from({ length: numberOfSteps }, (_, i) => (
        <div
          key={`step-${i}`}
          className={cn('rounded w-8 h-1 bg-[#D9D9D9]', {
            'bg-primary': i === currentStepIndex || i < currentStepIndex,
          })}
        />
      ))}
    </div>
  );
};

export default StepIndicator;
